import React from 'react'

const VirtualClassroom = () => {
  return (
    <div>VirtualClassroom</div>
  )
}

export default VirtualClassroom